webpackJsonp([65655651226304],{

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRedux = __webpack_require__(38);
	
	var _LoreHookRedux2 = _interopRequireDefault(_LoreHookRedux);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRedux2.default,
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook essentially just breaks up the standard Redux store creation process into a single of functions that can be overridden on a per-environment basis, so that you don\'t have to override the ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'entire'
	      ),
	      ' store creation process.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, in some environments (like development) you might want to override just the middleware, and apply apply a store enhancer to enable the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/gaearon/redux-devtools' },
	        'Redux DevTools'
	      ),
	      ', but leave the rest of the creation process the same.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This standard Redux Store build process looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { compose, applyMiddleware, combineReducers, createStore } from \'redux\';\n      import { thunk } from \'redux-thunk\';\n\n      const middleware = [thunk];\n      const enhancer = compose(\n        applyMiddleware.apply(null, middleware)\n      );\n      const rootReducer = combineReducers(reducers);\n      const preloadedState = {};\n      const store = createStore(rootReducer, preloadedState, enhancer);\n\n      // expose store on Lore instance\n      lore.store = store;\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This config file allows you to modify how Redux is constructed.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example Config File'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { applyMiddleware } from \'redux\';\n      import { thunk } from \'redux-thunk\';\n\n      export default {\n        middleware: [\n          applyMiddleware(thunk)\n        ]\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Configuration Options'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'middleware'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'What ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://redux.js.org/docs/advanced/Middleware.html' },
	        'middleware'
	      ),
	      ' you want Redux to use.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-redux-usage-index-js-606c5d23329e5083afb9.js